import { registerTranslation } from "@shoelace-style/localize";
const translation = {
  $code: "en",
  $name: "English",
  $dir: "ltr",
  close: "Close",
  loading: "Loading",
  badInput: "Not a valid URL format",
  typeMismatch: "Not a valid email format",
  patternMismatch: "Please match the requested format",
  rangeOverflow: (max, current) => `Please use no more than ${max} characters (you are currently using ${current} characters)`,
  rangeUnderflow: (min, current) => `Please use at least ${min} characters (you are currently using ${current} characters)`,
  valueMissing: "Please fill out this field",
  dateRange: "Date must be within the correct range",
  alert_info: "Important Information",
  alert_neutral: "Important Information",
  alert_warning: "Warning alert",
  alert_success: "Confirmation message",
  alert_error: "Error message",
  back_to_top: "Top",
  goodMorning: "Good Morning!",
  goodAfternoon: "Good Afternoon!",
  goodEvening: "Good Evening!",
  search: "Search",
  searchPlaceholder: "Enter a search term",
  menu: "Menu",
  your_progress: "Your Progress",
  complete: "Complete",
  step: "Step",
  of: "out of",
  optional: "optional",
  show: "Show",
  hide: "Hide",
  // TODO: Move app translations to correct repo
  shop: "Shop for a plan",
  zip: "Enter your zip code",
  forms_mode: "Turn on forms mode to access submenu",
  year: "year",
  years: "years",
  month: "month",
  months: "months",
  week: "week",
  weeks: "weeks",
  day: "day",
  days: "days",
  hour: "hour",
  hours: "hours",
  minute: "minute",
  minutes: "minutes",
  second: "second",
  seconds: "seconds",
  // CHC Date Picker
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "S",
  sunday_short: "S",
  monday_short: "M",
  tuesday_short: "T",
  wednesday_short: "W",
  thursday_short: "T",
  friday_short: "F",
  saturday_short: "S",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",
  january_short: "Jan",
  february_short: "Feb",
  march_short: "Mar",
  april_short: "Apr",
  may_short: "May",
  june_short: "Jun",
  july_short: "Jul",
  august_short: "Aug",
  september_short: "Sep",
  october_short: "Oct",
  november_short: "Nov",
  december_short: "Dec",
  instructions_one: "You can navigate by day using left and right arrows",
  instructions_two: "Weeks by using up and down arrows",
  instructions_three: "Months by using page up and page down keys",
  instructions_four: "Years by using shift plus page up and shift plus page down",
  instructions_five: "Home and end keys navigate to the beginning and end of a week",
  instructions_six: "Toggle Calendar",
  navigate_back_year: "Navigate back one year",
  navigate_back_month: "Navigate back one month",
  click_select_month: "Click to select month",
  click_select_year: "Click to select year",
  navigate_forward_month: "Navigate forward one month",
  navigate_forward_year: "Navigate forward one year",
  selected_date: "Selected date",
  back: "Navigate back",
  forward: "Navigate forward",
  showing_years: "Showing Years",
  select_year: "Select a year",
  select_month: "Select a month",
  to: "to"
};
registerTranslation(translation);
//# sourceMappingURL=en.js.map
